interface TrimPaginationSentinelOptions {
	paginated: boolean;
	pageSize?: number;
}

export function trimPaginationSentinel<T>(items: T[], options: TrimPaginationSentinelOptions) {
	if (!options.paginated || options.pageSize === undefined || items.length <= options.pageSize) {
		return items;
	}

	// Paginated reads request one extra item only to detect a following page.
	// Keep that sentinel out of listing state so visible rows and bulk selection
	// remain capped to the requested page size.
	return items.slice(0, options.pageSize);
}
